
const Product =({product}) => {

    //const storageLink = 'http:://localhost:8000/storage/media/';
    const thumbnail = "https://madadoo.kreatistheweb.com" + product.thumbnail;

    return (
        <div className="product-loop-item item" key={product.id}>
            <div className="product-image">
                <img src={thumbnail} alt="" title={product.title} />
            </div>
            <div className="product-body">                
                <div className="product-loop-price">
                    <span className="price">{product.price} XOF</span>
                </div>
                <h2 className="product-loop-title">{product.title}</h2>
                <div className="product-item-action mb-center">
                    <button className="btn btn-warning text-black btn-sm btn-bloc">Voir details</button>
                </div>
            </div>
        </div>
    );

};
export default Product;